import React from 'react';
import { useEffect, useLayoutEffect, useState } from 'react';
import '../App.css';
import '../assets/customStyles/experience.css';
import styled from '@emotion/styled'
import { Box as GBox } from 'grommet';
import Divider from '@mui/material/Divider';
import 'typeface-roboto';
import lottie from "lottie-web";
import handleViewport from 'react-in-viewport';

import patternAnimation from "../assets/images/patternAnimatedBg.json";
import stringWavesAnimation from "../assets/images/stringWaves.json";
const WorkInfo = styled.p`
font-size: 18px;
font-weight: "bold";
margin:6px;
text-align: left;
`

const Experience = () => {
  let [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector("#pattern-background"),
      animationData: stringWavesAnimation,
      autoplay: true,
      loop: false
    });

  }, []);

  useLayoutEffect(() => {
    function updateSize() {
      console.log(window.innerWidth)
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return (

    <div className='work-card-row'  style={{ position: 'relative', width: '74.4%',  marginTop: 25, marginBottom: 25, overflow: 'hidden', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',  minHeight: 400 }}>
      <GBox className='work-card' animation="zoomIn" elevation="xlarge" style={{ boxShadow: '2px 0px 17px 7px rgba(0,0,0,0.3)', color: '#212121', justifyContent: 'center', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginBottom: 20, backgroundColor: '#fff', width: 280, height: 260, borderRadius:30, padding:10  }}>

        <GBox direction="column" style={{ marginTop: 0 }} >
          
          <div style={{ padding: 10, textAlign: 'left' }}>
            <h5 style={{ color: 'rgb(7 155 224)', fontSize: 20, fontWeight: 800, margin: 0, padding: 0,marginBottom:6 }}>Web Application <br/> Developer </h5>
            <div className='divider-line-left'></div>
            <h6 style={{ color: '#212121', fontSize: 18, fontWeight: 700, margin: 0, padding: 0,marginTop:16 }}>Toonrush Inc. </h6>
            <h6 style={{ color: '#212121', fontSize: 15, fontWeight: 500, margin: 0, padding: 0 }}>May 2022 - Present</h6>
          </div>

          <GBox direction="column" style={{ margin: 0, padding: 10, paddingTop: 2, paddingBottom: 10, color: '#ff00ff', maxWidth: 500, height: 200 }}>
            <p style={{ textAlign: "left", margin: 2, fontSize: 16, color: '#212121' }}>Building responsive web applications using Angular and Python.  </p>
           
          </GBox>
          <div className='divider-line-right'></div>
        </GBox>
      </GBox>

      <GBox className='work-card' animation="zoomIn" elevation="xlarge" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', color: '#212121', justifyContent: 'center', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginBottom: 20, width: 280, height: 260, borderRadius:30, padding:10 ,backgroundColor:'rgb(254 112 39)' }}>
        <div className='diagnol-text' style={{display:'flex',}}>
             
        <GBox  direction="column" style={{ marginTop: 0}} >
          <div style={{ padding: 10, textAlign: 'left' }}>
            <h5 style={{ color: '#212121', fontSize: 20, fontWeight: 800, margin: 0, padding: 0, marginBottom:6 }}>React Full Stack Developer </h5>
            <div className='divider-line-left'></div>
            <h6 style={{ color: '#fff', fontSize: 18, fontWeight: 700, margin: 0, padding: 0,marginTop:16 }}>Lightspark Software Inc. </h6>
            <h6 style={{ color: '#fff', fontSize: 15, fontWeight: 500, margin: 0, padding: 0 }}>March 2022 - May 2022</h6>
          </div>
          <GBox direction="column" style={{ margin: 0, padding: 10, paddingTop: 2, paddingBottom: 10, color: '#ff00ff', maxWidth: 500, height: 200 }}>

            <p style={{ textAlign: "left", margin: 2, fontSize: 16, color: '#fff' }}>Developed responsve material design web app using React and Nest.js</p>

          </GBox>
          <div className='divider-line-right'></div>
        </GBox>
        </div>
      </GBox>



      <GBox  animation="zoomIn" elevation="xlarge" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', color: '#212121', justifyContent: 'center', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginBottom: 20, backgroundColor: '#fff',width: 280, height: 260, borderRadius:30, padding:10   }}>

        <GBox className='diagnol-text' direction="column" style={{ marginTop: 0 }} >
          <div style={{ padding: 10, textAlign: 'left' }}>
            <h5 style={{ color: 'rgb(7 155 224)', fontSize: 20, fontWeight: 800, margin: 0, padding: 0, marginBottom:6 }}>Application <br /> Developer </h5>
            <div className='divider-line-left'></div>
            <h6 style={{ color: '#000', fontSize: 18, fontWeight: 700, margin: 0, padding: 0, marginTop:16 }}>Logisitcs Software Corp. </h6>
            <h6 style={{ color: '#212121', fontSize: 15, fontWeight: 500, margin: 0, padding: 0 }}>May 2018 - March 2019</h6>
            <h6 style={{ color: '#000', fontSize: 15, fontWeight: 500, margin: 0, padding: 0 }}>February 2020 - May 2020</h6>
          </div>
          <GBox direction="column" style={{ margin: 0, padding: 10, paddingTop: 2, paddingBottom: 10, color: '#ff00ff', maxWidth: 500, height: 200 }}>

            <p style={{ textAlign: "left", margin: 2, fontSize: 16, color: '#000' }}>Building responsive web applications using Angular, SCSS and HTML. </p>

          </GBox>
          <div className='divider-line-right'></div>
        </GBox>
      </GBox>


    </div>

  )

}

export default Experience;